import { render, staticRenderFns } from "./inputTextArea.vue?vue&type=template&id=05c3ed4b&"
import script from "./inputTextArea.vue?vue&type=script&lang=js&"
export * from "./inputTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports